import { readReleaseChecks, type ReleaseChecks } from "../../../api/knowledgeData/releaseCheckDecoders";
import type { UiError } from "../../../errors/uiError";
import ReleaseChecksPanel from "./ReleaseChecksPanel";

/** The report of a release the checks refused (`dataset_checks_failed`): which members failed, against which model version, and why. */
export default function RefusedReleaseChecks({ error }: { error: UiError }) {
  const checks = refusedChecks(error);
  return checks === null ? null : <ReleaseChecksPanel checks={checks} />;
}

function refusedChecks(error: UiError): ReleaseChecks | null {
  if (error.kind !== "problem" || error.problem.code !== "dataset_checks_failed") return null;
  try {
    return readReleaseChecks(error.problem.details["checks"]);
  } catch {
    return null; // a report this web app cannot read: the error notice still says what happened
  }
}
